const STORAGE_PREFIX = 'ws_recent_v1';
const MAX_ITEMS = 6;

const RECENT_LABELS = {
  '/apps/tender': 'Tender Management',
  '/apps/tender/register': 'Tender register',
  '/apps/tender/knowledge': 'Knowledge bank',
  '/apps/tender/personnel': 'Personnel',
  '/apps/tender/timesheets': 'Timesheets',
  '/apps/tender/timesheets/week': 'Timesheet week',
  '/apps/tender/settings/timesheet': 'Timesheet rules',
  '/apps/tender/masters/timesheet-activities': 'Timesheet activities',
  '/apps/tender/approvals': 'Approvals',
  '/apps/tender/masters': 'Masters',
  '/apps/tender/masters/customers': 'Clients / Authorities',
  '/apps/tender/masters/services': 'Services',
  '/apps/tender/masters/sectors': 'Sectors',
  '/apps/tender/masters/tender-types': 'Tender types',
  '/apps/tender/masters/sources': 'Sources',
  '/apps/tender/reports': 'Reports',
  '/apps/tender/support': 'Support',
  '/apps/tender/my-work': 'My work',
  '/apps/tender/settings': 'Settings',
  '/apps/tender/settings/email': 'Email',
  '/apps/tender/settings/ai': 'AI',
  '/apps/tender/settings/notifications': 'Notifications',
  '/apps/tender/settings/dropdowns': 'Dropdown master',
  '/apps/tender/settings/dropdowns/tender-stages': 'Tender stages',
  '/apps/tender/settings/dropdowns/tender-priority': 'Priority',
  '/apps/tender/settings/dropdowns/tender-urgency': 'Urgency',
  '/apps/tender/profile': 'Settings',
  '/workspace': 'Workspace',
  '/my-work': 'My work'
};

function storageKey(userId) {
  return `${STORAGE_PREFIX}:${userId || 'anon'}`;
}

export function recordWorkspaceVisit(userId, pathname) {
  if (!pathname || !pathname.startsWith('/apps/')) return;
  const label = RECENT_LABELS[pathname] || pathname.replace(/\//g, ' · ').trim();
  try {
    const raw = localStorage.getItem(storageKey(userId));
    const list = raw ? JSON.parse(raw) : [];
    const next = [
      { path: pathname, label, visitedAt: Date.now() },
      ...list.filter((row) => row.path !== pathname)
    ].slice(0, MAX_ITEMS);
    localStorage.setItem(storageKey(userId), JSON.stringify(next));
  } catch {
    /* ignore quota / private mode */
  }
}

export function getWorkspaceRecent(userId) {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function formatRecentWhen(visitedAt) {
  if (!visitedAt) return '';
  const d = new Date(visitedAt);
  const now = new Date();
  const sameDay =
    d.getDate() === now.getDate()
    && d.getMonth() === now.getMonth()
    && d.getFullYear() === now.getFullYear();
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const isYesterday =
    d.getDate() === yesterday.getDate()
    && d.getMonth() === yesterday.getMonth()
    && d.getFullYear() === yesterday.getFullYear();

  const time = d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  if (sameDay) return `Today, ${time}`;
  if (isYesterday) return `Yesterday, ${time}`;
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}
